import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/material/locale";
import "../Theme/Theme.types";
export const theme = createTheme({
    direction: "rtl",
    palette: {
        primary: {
            main: "#00665A",
            light: "#B0D0CC",
            dark: "#002B26",
            contrastText: "#FFFFFF",
        },
        error: {
            main: "#C10101",
            light: "#ECB0B0",
            dark: "#6A0101",
            contrastText: "#FFFFFF",
        },
        success: {
            main: "#5EC101", // G-50
            light: "#B5E28A", // G-90
            dark: "#275100", // G-20
            contrastText: "#FFFFFF", // Pure White (On-Success)
        },
        warning: {
            main: "#C19101", // Y-50
            light: "#E2CC8A", // Y-90
            dark: "#513000", // Y-20
            contrastText: "#FFFFFF", // Pure White (On-Warning)
        },
        info: {
            main: "#019EC1", // B-50
            light: "#8AD2E2", // B-90
            dark: "#004251", // B-20
            contrastText: "#FFFFFF", // Pure White (On-Info)
        },
    },
    customColors: {
        primary: {
            98: "#E6F0EF",
            95: "#B0D0CC",
            90: "#BABBB3",
            80: "#54B8B0",
            60: "#33B57B",
            50: "#00865A",
            40: "#005D52",
            30: "#00484B",
            20: "#003832",
            10: "#002826",
            primaryContainer: "#E6F0EF",
            onPrimaryContainer: "#002826",
            onPrimary: "#FFFFFF",
        },
        neutral: {
            98: "#F4F4F4",
            95: "#EEEEEE",
            90: "#EBEBEB",
            80: "#D1D1D1",
            70: "#D1D1D1",
            50: "#A3A3A3",
            40: "#7F7F7F",
            30: "#616161",
            20: "#454545",
            10: "#121212",
            surfaceContainerLowest: "#FFFFFF",
            surfaceContainerLow: "#F4F4F4",
            surfaceContainer: "#EEEEEE",
            onSurface: "#121212",
            onSurfaceVariant: "#A3A3A3",
            outline: "#EBEBEB",
        },
        error: {
            98: "#FDF8F8",
            95: "#F9E6E6",
            90: "#ECB0B0",
            50: "#C10101",
            20: "#6A0101",
            errorContainer: "#F9E6E6",
            onErrorContainer: "#6A0101",
            onError: "#FFFFFF",
        },
        success: {
            98: "#F4F7F1", // Background tint
            95: "#EFF9E6", // Success Container (G-95)
            90: "#B5E28A", // Container variant
            50: "#5EC101", // Main success
            20: "#275100", // Darkest
            successContainer: "#EFF9E6", // G-95
            onSuccessContainer: "#275100", // G-20 (On-Success-Container)
            onSuccess: "#FFFFFF", // Pure White
        },
        warning: {
            98: "#F9F6F4", // Background tint
            95: "#F9F4E6", // Warning Container (Y-95)
            90: "#E2CC8A", // Container variant
            50: "#C19101", // Main warning
            20: "#513000", // Darkest
            warningContainer: "#F9F4E6", // Y-95
            onWarningContainer: "#513000", // Y-20 (On-Warning-Container)
            onWarning: "#FFFFFF", // Pure White
        },
        info: {
            98: "#F2F7F8", // Background tint
            95: "#E8F5F9", // Info Container (B-95)
            90: "#8AD2E2", // Container variant
            50: "#019EC1", // Main info
            20: "#004251", // Darkest
            infoContainer: "#E8F5F9", // B-95
            onInfoContainer: "#004251", // B-20 (On-Info-Container)
            onInfo: "#FFFFFF", // Pure White
        },
    },
    typography: {
        fontFamily: ["IRANSansX", "IRANSansXBold"].join(","),
        displayLarge: {
            fontSize: "48px",
            lineHeight: "72px",
            fontWeight: 700,
            color: "#000000",
        },
        displaySmall: {
            fontSize: "32px",
            lineHeight: "56px",
            fontWeight: 700,
            color: "#000000",
        },
        headlineLarge: {
            fontSize: "24px",
            lineHeight: "44px",
            fontWeight: 700,
            color: "#000000",
        },
        titleLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 700,
            color: "#000000",
        },
        titleMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#000000",
        },
        labelLarge: {
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#000000",
        },
        labelMedium: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#000000",
        },
        labelSmall: {
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
            color: "#000000",
        },
        bodyLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 500,
            color: "#000000",
        },
        bodyMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#000000",
        },
        bodySmall: {
            fontSize: "12px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#000000",
        },
    },
}, faIR);
